import React from 'react';
import Navbar from './Navbar';
import FooterComp from './Footer';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      <Navbar />
      {children}
      <FooterComp />
    </div>
  );
};

export default Layout;
